export const extractError = (error: any): [{ '@value': any }] => {
    const body = error.body;
    const errorItem = body[0];
    return errorItem['http://www.w3.org/ns/hydra/core#description'];
};
